import { createFileRoute } from '@tanstack/react-router'
import { AccountingPage } from '@/features/accounting'

export const Route = createFileRoute('/_authenticated/payouts/')({
  component: () => (
    <AccountingPage
      kind='payouts'
      
      mode='operations'
      reviewPermission='payout.review'
      pageKey='payoutOps'
    />
  ),
})
